import type { SVGProps } from "react";
export interface SeedlingPotIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SeedlingPotIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SeedlingPotIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.112 10.88c.618.063 1.07.613 1.008 1.231l-.73 7.3a4.126 4.126 0 0 1-4.105 3.714h-6.57a4.126 4.126 0 0 1-4.105-3.714l-.73-7.3-.005-.114a1.125 1.125 0 0 1 2.227-.223l.017.115.73 7.297a1.876 1.876 0 0 0 1.866 1.69h6.57c.963 0 1.77-.731 1.866-1.69l.73-7.297a1.126 1.126 0 0 1 1.231-1.008Z"
      />
      <path
        fill={color}
        d="M13.864 1.98C15.486.816 17.61.666 20.186 1.099c.542.09.94.56.94 1.109 0 2.639-.855 4.673-2.655 5.85-1.432.937-3.284 1.206-5.347 1.024v1.795H20l.115.005a1.126 1.126 0 0 1 0 2.239l-.115.006H4a1.125 1.125 0 0 1 0-2.25h6.874V9.08c-2.062.182-3.913-.087-5.345-1.024-1.8-1.177-2.654-3.211-2.654-5.85 0-.55.397-1.018.939-1.11 2.577-.432 4.7-.282 6.322.884.789.567 1.392 1.328 1.863 2.247.472-.92 1.076-1.68 1.865-2.247m-5.04 1.83c-.76-.546-1.87-.809-3.646-.63.174 1.552.775 2.467 1.582 2.995.846.554 2.113.815 3.842.672C10.146 5.27 9.56 4.34 8.824 3.81m9.997-.628c-1.775-.18-2.886.082-3.644.627-.737.53-1.325 1.46-1.78 3.038 1.729.143 2.995-.118 3.842-.672.807-.528 1.408-1.442 1.582-2.993"
      />
    </svg>
  );
}
